// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, onMessage } from "firebase/messaging";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCq4RE0LX_IPBFwojE1WuhL7giWe7SYcgs",
  authDomain: "emanage-d689d.firebaseapp.com",
  projectId: "emanage-d689d",
  storageBucket: "emanage-d689d.firebasestorage.app",
  messagingSenderId: "178040582421",
  appId: "1:178040582421:web:f9beafa83021efdcefb91c",
  measurementId: "G-G7SH2LPH4H"
};

export const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

onMessage(messaging, (payload) => {
  console.log('[foreground] message received', payload);

  if (!payload || !payload.data) {
    return;
  }

  try {
    const data = payload.data;

    const title = data.title || 'Notification';
    const options = {
      body: data.body || '',
      icon: '/favicon.ico',
      tag: data.tag || 'notification-tag',
      renotify: !!data.tag,
      silent: false,
      requireInteraction: false,
      data: data
    };

    if (Notification.permission === 'granted') {
      const notification = new Notification(title, options);

      notification.onclick = (event) => {
        event.preventDefault();
        window.focus();
        const url = data.click_action || data.url || '/';
        if (url) window.location.href = url;
        notification.close();
      };
    } else {
      console.warn('[foreground] permission not granted for foreground notification');
    }
  } catch (error) {
    console.error('Foreground notification error:', error);
  }
});